import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: { type: Number, default: 3000 } }

  connect() {
    this.timeout = setTimeout(() => this.close(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  close() {
    clearTimeout(this.timeout)
    this.element.classList.add("opacity-0", "translate-y-2")

    setTimeout(() => {
      this.element.remove()
    }, 180)
  }
}
